module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('media', {
    attrs: {
      "query": "(max-width: 39.9375em)"
    }
  }, [_c('div', {
    staticClass: "destinations-building"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "destinations-container"
  }, _vm._l((_vm.locations), function(location) {
    return _c('location', {
      key: location.name,
      attrs: {
        "location": location
      }
    })
  }))]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "map-container"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-container"
  }, [_c('button', {
    class: {
      'current-selected': _vm.currentIndex === 0
    },
    on: {
      "click": function($event) {
        _vm.show(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                    Regions\n                ")]), _vm._v(" "), _c('button', {
    class: {
      'current-selected': _vm.currentIndex === 1
    },
    on: {
      "click": function($event) {
        _vm.show(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                    Map\n                ")])])], 1)]), _vm._v(" "), _c('media', {
    attrs: {
      "query": "(min-width: 40em) and (max-width: 63.9375em)"
    }
  }, [_c('div', {
    staticClass: "destinations-building"
  }, [_c('div', {
    staticClass: "destinations-container"
  }, _vm._l((_vm.locations), function(location) {
    return _c('location', {
      key: location.name,
      attrs: {
        "location": location
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  })])]), _vm._v(" "), _c('media', {
    attrs: {
      "query": "(min-width: 64em)"
    }
  }, [_c('div', {
    staticClass: "destinations-building"
  }, [_c('div', {
    staticClass: "destinations-container"
  }, _vm._l((_vm.firstHalf), function(location) {
    return _c('location', {
      key: location.name,
      attrs: {
        "location": location
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }), _vm._v(" "), _c('div', {
    staticClass: "destinations-container destinations-container--second"
  }, _vm._l((_vm.secondHalf), function(location) {
    return _c('location', {
      key: location.name,
      attrs: {
        "location": location
      }
    })
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4efd384c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/destinations/destinations.vue
// module id = 174
// module chunks = 6